export default ({ to, from, next }) => {
    if (localStorage.getItem('userToken')) {
        next('/meter-configs')
        
        return false;
    }

    next()
}